export type PermissionValues =
  "Get" | "Post" |
  "Put" | "Delete" | "Manage" | "Same";
export class Permission {
  public static readonly viewPermission: PermissionValues = "Get";
  public static readonly editPermission: PermissionValues = "Put";
  public static readonly createPermission: PermissionValues = "Post";
  public static readonly deletePermission: PermissionValues = "Delete";
  public static readonly managePermission: PermissionValues = "Manage";
  public static readonly samePermission: PermissionValues = "Same";
  constructor(value?: PermissionValues, groupName?: string, description?: string) {
    this.value = value;
    this.groupName = groupName;
    this.description = description;
  }
  public value: PermissionValues;
  public groupName: string;
  public description: string;
}
